import styled, { css } from "styled-components";

export const StyledTabs = styled.div`
  display: flex;
  border-bottom: 1px solid var(--color-text-20);
  gap: var(--spacing-sm);
`;

export const StyledTabItem = styled.button<{
  $active: boolean;
}>`
  font-size: var(--font-size-md);
  font-weight: 600;
  border-bottom: 2px solid;
  transition: all var(--transition-fast);
  padding: var(--spacing-sm) var(--spacing-xs);
  ${({ $active }) => $active ? css`
    color: var(--color-primary);
    border-color: var(--color-primary);
  ` : css`
    color: var(--color-text-80);
    border-color: transparent;
  `}
`;
